// Browser-notification reminders for the circadian coach (sleep window + caffeine cut-off).
export const REMINDERS_KEY = "vespera_reminders";

export function remindersEnabled() {
  return localStorage.getItem(REMINDERS_KEY) === "1";
}

export function setRemindersEnabled(on) {
  localStorage.setItem(REMINDERS_KEY, on ? "1" : "0");
}

export function parseFirstTime(str) {
  const m = String(str || "").match(/(\d{1,2}):(\d{2})/);
  if (!m) return null;
  return { h: Number(m[1]), m: Number(m[2]) };
}

export async function requestPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  return Notification.requestPermission();
}

let timers = [];

export function clearScheduled() {
  timers.forEach((id) => clearTimeout(id));
  timers = [];
}

// Schedule today's reminders based on the coach recommendation. `t` is the i18n translator.
export function scheduleReminders(coach, t) {
  clearScheduled();
  if (!("Notification" in window) || Notification.permission !== "granted" || !coach) return;
  const now = new Date();
  const plan = [
    [coach.sleep_window, t("reminderSleepTitle"), t("reminderSleepBody")],
    [coach.caffeine_cutoff, t("reminderCaffeineTitle"), t("reminderCaffeineBody")],
  ];
  plan.forEach(([time, title, body]) => {
    const p = parseFirstTime(time);
    if (!p) return;
    const when = new Date();
    when.setHours(p.h, p.m, 0, 0);
    const delay = when.getTime() - now.getTime();
    if (delay > 0 && delay < 24 * 3600 * 1000) {
      timers.push(setTimeout(() => {
        try { new Notification(title, { body }); } catch { /* ignore */ }
      }, delay));
    }
  });
}
